// icon:heart | Tabler Icons https://tablericons.com/ | Csaba Kissi
import * as React from 'react'

function IconDeathX(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      height="1em"
      width="1em"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M46 36.4836L36.5714 45.8883L2 11.4046L11.4286 2L46 36.4836Z"
        fill="currentColor"
        />
      <path
        d="M38.5 2.88825C36.7438 2.88825 35.8947 3.20514 34.7799 4.38825L35.3634 3.80621L3.93487 35.155L5.2048 33.8883C4.13685 34.9858 3.88858 35.8347 3.88857 37.485C3.88857 40.8517 6.62475 43.5809 10 43.5809C11.754 43.5809 12.8855 43.0687 14 41.8883L43 13.3883C44.1861 12.2763 44.6114 10.7359 44.6114 8.98415C44.6114 5.61748 41.8752 2.88825 38.5 2.88825Z"
        fill="currentColor"
        />
    </svg>

  )
}

export default IconDeathX
